import { useFeature } from 'flagged';
import { ConfigFeatureFlags } from '../services/service-config-types';
var useDisputesFooterLinkFeature = function (_a) {
    var accountFeatures = _a.accountFeatures;
    var isDisputesFooterLinkEnabled = useFeature(ConfigFeatureFlags.disputesFooterLink);
    return (isDisputesFooterLinkEnabled && Boolean(accountFeatures === null || accountFeatures === void 0 ? void 0 : accountFeatures.accessToDisputes));
};
export default useDisputesFooterLinkFeature;
//# sourceMappingURL=use-disputes-footer-link-feature.js.map